import { nsSelector, selector } from '../../../../../../../utils/redux';

const activitiesSelector = nsSelector('machinery');

export const machineries = activitiesSelector('list');
